import { ExternalLink, Youtube } from 'lucide-react'
import type { HorseVideo } from '../data/site'
import { socialLinks } from '../data/site'

type HorseVideosProps = {
  horseName: string
  videos: HorseVideo[]
}

export default function HorseVideos({ horseName, videos }: HorseVideosProps) {
  return (
    <section className="section horse-videos" aria-labelledby="horse-videos-heading">
      <div className="container">
        <div className="horse-videos__heading">
          <div>
            <span className="eyebrow">Sanctuary videos</span>
            <h2 id="horse-videos-heading">{horseName} in motion</h2>
            <p>Spend a little more time getting to know {horseName} through moments shared by the sanctuary.</p>
          </div>
          <a className="text-link" href={socialLinks.youtube} target="_blank" rel="noopener noreferrer">
            Watch Unique Diamond Horse Sanctuary on YouTube <ExternalLink aria-hidden="true" />
          </a>
        </div>

        <div className={`horse-video-strip${videos.length === 1 ? ' horse-video-strip--single' : ''}`}>
          {videos.map((video) => (
            <article className="horse-video-card" key={video.youtubeId}>
              <div className="horse-video-card__frame">
                <iframe
                  src={`https://www.youtube-nocookie.com/embed/${video.youtubeId}`}
                  title={`${video.title} — ${horseName} at Unique Diamond Horse Sanctuary`}
                  loading="lazy"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allow="accelerometer; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                />
              </div>
              <div className="horse-video-card__title">
                <Youtube aria-hidden="true" />
                <div>
                  <h3>{video.title}</h3>
                  <p>This video features {horseName}, a resident of Unique Diamond Horse Sanctuary.</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
